import { Component } from "react"

/* Link */
import { Link, NavLink } from "react-router-dom"

/* Redux */
import { connect } from "react-redux"

/* Constants */
import { menu } from "../constants"

/* Timezone Switcher */
import TimezoneSwitcher from "./TimezoneSwitcher"

/* Translate */
import { t } from "../translates/translate"



/* Widget Menu */
class Menu extends Component {


    /* Language Switcher */
    _languageSwitcher = () => {

        const { language, setLanguage, minimized } = this.props

        return (
            <div className="menu-lang-switcher">
                <div
                    onClick={() => setLanguage("ru")}
                    className={`menu-lang-item ${language === "ru" ? "active" : ""}`}
                >
                    {minimized ? "RU" : t("lang.ru")}
                </div>
                <div
                    onClick={() => setLanguage("en")}
                    className={`menu-lang-item ${language === "en" ? "active" : ""}`}
                >
                    {minimized ? "EN" : t("lang.en")}
                </div>
            </div>
        )
    }


    render = () => {

        const { minimized, toggle, admin } = this.props

        return (
            <div className={`menu ${minimized ? "minimized" : ""}`}>

                <div className="menu-inner">

                    <Link to="/" className="menu-logo">
                        <span>
                            <img src="/images/logo.png" alt="Logo" />
                        </span>
                        <h1>Game Center</h1>
                    </Link>

                    <div className="menu-box">
                        {menu.getData().map((item, index) => {

                            if (item.superadmin && !(admin && admin.isAdmin)) {
                                return null
                            }

                            if (item.extended && !(admin && (admin.isAdmin || admin.extendedAccess))) {
                                return null
                            }

                            if (item.name === "space") {
                                return <div className="menu-space" key={`${index}`} />
                            }

                            return (
                                <NavLink key={`${index}`} to={item.link} className="menu-item">
                                    <div className="menu-image">
                                        {item.image}
                                    </div>
                                    <span>{item.text}</span>
                                </NavLink>
                            )
                        })}
                    </div>

                    {this._languageSwitcher()}

                    <TimezoneSwitcher minimized={minimized} />

                </div>

                <div onClick={() => toggle()} className={`menu-arrow ${minimized ? "active" : ""}`}>
                    <img src="/images/left-chevron.png" alt="Left Chevron" />
                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        admin: state.admin,
        language: state.language,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setLanguage: (lang) => dispatch({ type: "SET_LANGUAGE", payload: lang }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu)
